import { gql } from "@apollo/client";

export const DISTRIBUTORS_QUERY = gql`
  query Distributors {
    distributorList {
      items {
        assignmentType
        coverage
        distributorName
        kdpFlag
        regionsServed
      }
    }

    distributorReportedDollarSolds {
      items {
        cmcYvsCMLY
        cMvsGoal
        cMvsLM
        cqcYvsCQLY
        cQvsGoal
        cQvsLQ
        currentMonth
        currentQuarter
        currentYear
        cYvsGoal
        cYvsLY
        goalCurrentMonth
        goalCurrentQuarter
        goalCurrentYear
        lastMonth
        lastQuarter
        lastYear
        sameMonthLastYear
        sameQuarterLastYear
      }
    }

    distributorReportedUnitsSolds {
      items {
        cmcYvsCMLY
        cMvsGoal
        cMvsLM
        cqcYvsCQLY
        cQvsGoal
        cQvsLQ
        currentMonth
        currentQuarter
        currentYear
        cYvsGoal
        cYvsLY
        goalCurrentMonth
        goalCurrentQuarter
        goalCurrentYear
        lastMonth
        lastQuarter
        lastYear
        sameMonthLastYear
        sameQuarterLastYear
      }
    }

    distributorInventoryTurnovers {
      items {
        cmcYvsCMLY
        cMvsGoal
        cMvsLM
        cqcYvsCQLY
        cQvsGoal
        cQvsLQ
        currentMonth
        currentQuarter
        currentYear
        cYvsGoal
        cYvsLY
        goalCurrentMonth
        goalCurrentQuarter
        goalCurrentYear
        lastMonth
        lastQuarter
        lastYear
        sameMonthLastYear
        sameQuarterLastYear
      }
    }

    distributorAvailablePhysicalStocks {
      items {
        cmcYvsCMLY
        cMvsGoal
        cMvsLM
        cqcYvsCQLY
        cQvsGoal
        cQvsLQ
        currentMonth
        currentQuarter
        currentYear
        cYvsGoal
        cYvsLY
        goalCurrentMonth
        goalCurrentQuarter
        goalCurrentYear
        lastMonth
        lastQuarter
        lastYear
        sameMonthLastYear
        sameQuarterLastYear
      }
    }

    distributorDaysOfInventories {
      items {
        cmcYvsCMLY
        cMvsGoal
        cMvsLM
        cqcYvsCQLY
        cQvsGoal
        cQvsLQ
        currentMonth
        currentQuarter
        currentYear
        cYvsGoal
        cYvsLY
        goalCurrentMonth
        goalCurrentQuarter
        goalCurrentYear
        lastMonth
        lastQuarter
        lastYear
        sameMonthLastYear
        sameQuarterLastYear
      }
    }

    distributorTotalNumberOfDeliveries {
      items {
        cmcYvsCMLY
        cMvsGoal
        cMvsLM
        cqcYvsCQLY
        cQvsGoal
        cQvsLQ
        currentMonth
        currentQuarter
        currentYear
        cYvsGoal
        cYvsLY
        goalCurrentMonth
        goalCurrentQuarter
        goalCurrentYear
        lastMonth
        lastQuarter
        lastYear
        sameMonthLastYear
        sameQuarterLastYear
      }
    }
    distributorSKULowestDaysOfInventory {
      items {
        lastPeriodNetSales
        name
        netSales
        percentage
        rank
        unitSold
      }
    }
    distributorReportedUnitSalesBySubBrand {
    items {
      lastPeriodNetSales
      name
      netSales
      percentage
      rank
      unitSold
    }
  }
    distributorRetailerByUnitSales {
      items {
        lastPeriodNetSales
        name
        netSales
        percentage
        rank
        unitSold
      }
    }
      distributorReportedUnitSalesByChannel {
      items {
      lastPeriodNetSales
      name
      netSales
      percentage
      rank
      unitSold
      }
  }
    distributorReportedUnitSalesByRegion {
      items {
      lastPeriodNetSales
      name
      netSales
      percentage
      rank
      unitSold
      }
  }
      distributorSubBrandByUnitSales {
      items {
        lastPeriodNetSales
        name
        netSales
        percentage
        rank
        unitSold
      }
    }

      distributorReportedUnitsSoldSubBrandMonthly {
      items {
        values {
          casesOrdered
          subBrandName
        }
        month
      }
    }

      distributorCasesOverTimes {
      items {
        casesInStock
        casesOrdered
        casesSold
        month
      }
    }

    distributorOTIFOverTimes {
      items {
        month
        onTimeDelivery
        orderFillRate
        perfectOrderRate
      }
    }
     distributorBottom10OrderedSKUs {
    items {
      rank
      sku
      value
    }
  }
  distributorTop10OrderedSKUs {
    items {
      rank
      sku
      value
    }
  }
  }
`;
